
import React, { Component, Fragment } from "react";
import {
    Button
} from 'reactstrap';

class DownloadCSV extends Component {

    constructor(props) {
        super(props);
        this.state = {
            csvData: this.convertJsonToCsv(this.props.data),

        }

    }
    convertJsonToCsv = (jsonArray) => {
        const header = Object.keys(jsonArray[0]).join(',') + '\n';
        const rows = jsonArray.map((row) => Object.values(row).join(',')).join('\n');
        return header + rows;
    };

    // Function to trigger CSV download
    downloadCsv = (csvData, filename) => {
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    };

    handleDownload = () => {
        console.log("Download" + this.props.imagePath)
        if (this.props.imagePath) {
            fetch(this.props.imagePath)
                .then(response => response.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'image.jpg');
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                })
                .catch(error => console.error('Error downloading image:', error));
        }
    }
    render() {
        return (
            <div className="btn-actions-pane-right downloadImage" style={{ textAlign: "right" }}>
                <Button
                    className="btn-shadow"
                    color="primary"
                    onClick={() => this.downloadCsv(this.state.csvData, 'data.csv')}
                >

                    <i
                        className="pe-7s-download"
                    />

                </Button>
            </div>
        )
    }
}

export default DownloadCSV;